import { render } from "./code-editor.vue?vue&type=template&id=21a19e4b"
import script from "./code-editor.vue?vue&type=script&lang=js"
export * from "./code-editor.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Usuario\\Documents\\Git-Repositorios\\edge_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__